import { Box, Stack, Typography, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { FC } from "react";
import { DashboardRowButton } from "web_myplann/Dashboard/Components/DashboardRowButton";
import type { DashboardDetailRowData } from "web_myplann/Dashboard/Utils/dashboardDetailRows";
import { PortfolioItemIcon } from "web_myplann/Portfolio/Components/PortfolioItemIcon";
import { PerformanceBadge } from "web_myplann/Portfolio/Components/Redesign/ListItem/PerformanceBadge";

type Props = {
	row: DashboardDetailRowData;
	isLast: boolean;
	onClick: () => void;
};

export const DashboardDetailRow: FC<Props> = ({ row, isLast, onClick }) => {
	const { palette, iconSize, spacingTokens } = useTheme();

	return (
		<DashboardRowButton onClick={onClick} showDivider={!isLast}>
			<PortfolioItemIcon
				domain={row.domain}
				propertyType={row.propertyType}
				logo={row.logo}
			/>

			<Stack flex={1} minWidth={0}>
				<Typography
					variant="bodyStrong"
					overflow="hidden"
					whiteSpace="nowrap"
					textOverflow="ellipsis"
				>
					{row.name}
				</Typography>
				{row.subtitle && (
					<Typography
						variant="caption"
						color={palette.grey[500]}
						overflow="hidden"
						whiteSpace="nowrap"
						textOverflow="ellipsis"
					>
						{row.subtitle}
					</Typography>
				)}
				{row.extra && (
					<Typography variant="hint" mt={spacingTokens.xxs}>
						{row.extra}
					</Typography>
				)}
			</Stack>

			{row.valueText && (
				<Stack alignItems="flex-end" flexShrink={0} gap={spacingTokens.xxs}>
					<Typography variant="bodyStrong" tabular>
						{row.valueText}{" "}
						<Typography
							component="span"
							variant="caption"
							sx={{ opacity: 0.7 }}
						>
							{row.currencySign}
						</Typography>
					</Typography>
					<PerformanceBadge percent={row.change} />
				</Stack>
			)}

			<Box flexShrink={0} display="inline-flex">
				<ChevronRight size={iconSize.sm} color={palette.grey[400]} />
			</Box>
		</DashboardRowButton>
	);
};
